import { asapScheduler, Observable, } from "rxjs";
import { OperatorSubscriber } from "../OperatorSubscriber";
export function debounceSync() {
    return (source) => new Observable((subscriber) => {
        let actionSubscription;
        let actionValue;
        source.subscribe(new OperatorSubscriber(subscriber, {
            complete: () => {
                if (actionSubscription) {
                    subscriber.next(actionValue);
                }
                subscriber.complete();
            },
            error: (error) => subscriber.error(error),
            next: (value) => {
                actionValue = value;
                if (!actionSubscription) {
                    actionSubscription = asapScheduler.schedule(() => {
                        subscriber.next(actionValue);
                        actionSubscription = undefined;
                    });
                    subscriber.add(actionSubscription);
                }
            },
        }));
    });
}
//# sourceMappingURL=debounceSync.js.map